// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1gImE","inner":"Footer_inner__1kdFa","nextIcon":"Footer_nextIcon__1Qwv3","innerLeft":"Footer_innerLeft__1_1Wh"};